export default __webpack_public_path__ + "static/media/z020di0b.4f59c99d.mp3";